import { Component, Vue } from "vue-property-decorator"
import app from '@/api/app'
import { getInvoiceBaseInfo, getInvoiceTitleList, createInvoice } from '@/api/invoiceApi'
import invoiceDetail from '../components/invoiceDetail.vue'
import invoiceTitleList from '../components/invoiceTitleList.vue'
import invoiceSuccess from '../components/invoiceSuccess.vue'
import { validEmail } from '@/utils/validata'
import { getHeadPadding } from '@/utils/common'

@Component({
  components: {
    invoiceDetail,
    invoiceTitleList,
    invoiceSuccess
  }
})
export default class IssueInvoice extends Vue {

  // data
  private form = {
    titleType: 1,
    titleName: undefined,
    taxNumber: undefined,
    email: undefined,
    amount: undefined,
    registeredAddress: undefined,
    registeredPhone: undefined,
    bankAccount: undefined,
    bankName: undefined,
    remark: undefined
  }
  // 标题
  private title: string = '开具发票'
  // 详情显示 0---主页 1----详情 2----抬头 3---开票成功
  private detailShow: number = 0
  // 抬头动作栏显示
  private show: boolean = false
  // 自定义图标
  private inactiveIcon: any = require('@/assets/images/invoive/unselecte.png')
  private activeIcon: any = require('@/assets/images/invoive/selected.png')
  // 发票类型列表
  private typeList: any[] = [{label: '企业单位', value: '1'}, {label: '个人/非企业单位', value: '2'}]
  // 抬头列表
  private titleList: any[] = []
  // 详情列表
  private detailList: any[] = []
  // 小区id
  private communityId: any = localStorage.getItem("communityId")
  // 订单号
  private chargeOrderId: any = localStorage.getItem("chargeOrderId")
  private headerHeight: string = '0'


  created() {
    this.communityId = this.$route.query.communityId
    this.chargeOrderId = this.$route.query.orderId
    let token: any = this.$route.query.token
    localStorage.setItem("communityId", this.communityId)
    localStorage.setItem("token", token)
    localStorage.setItem("chargeOrderId", this.chargeOrderId)
  }

  // 计算属性
  get isOK() {
    if (this.form.titleType === 0) {
      return this.form.titleName && this.form.taxNumber && this.form.email
    } else {
      return this.form.titleName && this.form.email
    }
  }
  // 获取store的发票信息
  get userInfo() {
    return this.$store.getters.invoiceInfo
  }

  // 已填写数量
  get fillCount() {
    let count = 0
    if ( this.form.registeredAddress) {
      count++
    }
    if ( this.form.registeredPhone) {
      count++
    }
    if ( this.form.bankAccount) {
      count++
    }
    if ( this.form.bankName) {
      count++
    }
    if ( this.form.remark) {
      count++
    }
    return count
  }

  // mounted
  mounted() {
    this.getInvoiceBaseInfo()
    this.headerHeight = getHeadPadding() || '0'
  }

  // methods
  getInvoiceBaseInfo() {
    // @ts-ignore
    this.$loading('努力加载中')
    getInvoiceBaseInfo().then(res => {
      this.form.amount = res.data.amount
      const defaultInfo = res.data.defaultTitle
      this.detailList = res.data.chargeOrderDetailList
      if (defaultInfo) {
        this.form.titleName = defaultInfo.title || ''
        this.form.titleType = defaultInfo.type
        this.form.taxNumber = defaultInfo.taxNumber || ''
        this.form.registeredAddress = defaultInfo.registeredAddress || ''
        this.form.registeredPhone = defaultInfo.registeredPhone || ''
        this.form.bankAccount = defaultInfo.bankAccount || ''
        this.form.bankName = res.data.defaultTitle.bankName || ''
        this.form.remark = res.data.defaultTitle.remark || ''
      } else {
        // @ts-ignore
        this.form.titleType = '2'
      }
      if (this.userInfo.titleName) {
        Object.assign(this.form, this.userInfo)
      }
      this.$toast.clear()
    })
  }
  // 选额抬头
  selectTitle(item: { title: any; taxNumber: any; bankName: any; registeredAddress: any; registeredPhone: any; remark: any; bankAccount: any; }) {
    this.$set(this.form, 'titleName', item.title)
    this.$set(this.form, 'taxNumber', item.taxNumber)
    this.$set(this.form, 'bankName', item.bankName)
    this.$set(this.form, 'registeredAddress', item.registeredAddress)
    this.$set(this.form, 'registeredPhone', item.registeredPhone)
    this.$set(this.form, 'remark', item.remark)
    this.$set(this.form, 'bankAccount', item.bankAccount)
    this.show = false
  }
  // 添加常用发票抬头
  toAddTitle() {
    this.$store.commit('SET_INVOICE_INFO', this.form)
    // @ts-ignore
    this.$router.push({ name: 'setInvoiceTitle', params: {type: this.form.titleType}})
  }
  openTitleList() {
    if (this.titleList.length === 0) {
      return this.toAddTitle()
    }
    this.show = false
    this.detailShow = 2
    this.title = '我的发票抬头'
  }
  // 去更多页面
  goToMorePage() {
    this.$store.commit('SET_INVOICE_INFO', this.form)
    this.$router.push('/invoiceMore')
  }
  // 详情点击
  detailShowClick() {
    this.detailShow = 1
    this.title = '发票详情'
  }
  // 获取抬头列表
  getInvoiceTitleList(isShow=true) {
    // @ts-ignore
    this.$loading('努力加载中')
    getInvoiceTitleList(this.form.titleType).then(res => {
      this.titleList = res.data.list
      if (isShow) {
        this.show = true
      }
      this.$toast.clear()
    })
  }

  // 开票
  submit() {
    if (!validEmail(this.form.email)) {
      return this.$$message('请输入合法的邮箱')
    }
    this.$loading('努力加载中')
    createInvoice(this.form).then(res => {
      this.$toast.clear()
      if (res.status === 'OK') {
        this.detailShow = 3
      }
    })
  }

  // 返回app
  goBack() {
    if (this.detailShow !== 0) {
      this.detailShow = 0
    } else {
      this.clearStore()
      app.goBack()
    }
  }
  // 关闭
  goClose() {
    this.clearStore()
    app.goBack()
  }
  // 清空缓存
  clearStore() {
    this.$store.commit('SET_INVOICE_INFO', {})
  }
}
